import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { InvestmentPropertyPreviewCardComponent } from './investment-property-preview-card.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        PipesModule
    ],
    declarations: [
        InvestmentPropertyPreviewCardComponent
    ],
    exports: [
        InvestmentPropertyPreviewCardComponent
    ]
})

export class InvestmentPropertyPreviewCardModule { }
